export const ROUTE_PATHS = {
  LOGIN: '/login',
}
